export const messageMapper = ({ is_from_co: isFromCO, ...rest }) => ({
  isFromCO,
  ...rest
});
